export const SETUP_GOALS = {
  MAXIMIZE_SPECIFIC_RISK: "maximizeSpecificRisk",
  TARGET_TOTAL_RISK: "targetTotalRisk",
  MIN_VOLATILITY: "minVolatility",
} as const

export type SetupGoal = (typeof SETUP_GOALS)[keyof typeof SETUP_GOALS]
